// auth

export const ME_FETCH = "me/fetch";
export const ME_FETCH_USER = "me/fetch_user";
export const ME_LOADING = "me/loading";
export const ME_LOADING_ERROR = "me/loading_error";
export const ME_SENDING_DATA = "me/sending_data";

// singup

export const REGISTER_USER_LOADING = "register/loading";
export const REGISTER_USER_ERROR = "register/loading_error";
export const REGISTER_USER_SEND_DATA = "register/send_data";
export const REGISTER_USER_INFO = "register/user_info";

// course-register

export const COURSE_REGISTER_SEND_DATA = "course-register/send";
export const COURSE_REGISTER_LOADING = "course-register/loading";
export const COURSE_REGISTER_ERROR = "course-register/error";
export const COURSE_DATA = "course/data";
export const COURSE_ID_DATA = "course/id_data";
export const COURSE_ID = "course/id";
export const COURSE_ALL_DATA = "course/all_data";
export const COURSE_ALL = "course/all";

// enroll-course
export const COURSE_ENROLL = "course/enroll";
export const COURSE_ENROLL_SEND_DATA = "course/enroll_send_data";
export const COURSE_ENROLL_LOADING = "course/enroll_loading";
export const COURSE_ENROLL_ERROR = "course/enroll_error";
